import { useRouter } from "@tanstack/react-router"
import { useEffect } from "react"

interface NavigationDetail {
  to: string
  params?: Record<string, string>
  search?: Record<string, string | undefined>
}

const useListenerNavigation = () => {
  const router = useRouter()

  useEffect(() => {
    const handleNavigation = (event: CustomEvent<NavigationDetail>) => {
      const { to, params, search } = event.detail
      router.navigate({ to, params, search })
    }
    window.addEventListener("navigationAction", handleNavigation as EventListener)
    return () => {
      window.removeEventListener("navigationAction", handleNavigation as EventListener)
    }
  }, [router])

  return { navigate: router.navigate }
}

export default useListenerNavigation
